module.exports = __webpack_public_path__ + "fonts/Inter-Regular.46a1550a.woff2";